// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from "element-ui";

import "@/theme/element-ul/index.css";
Vue.use(ElementUI, {
    size: "small"
});

import axios from "axios";
Vue.prototype.$axios = axios;

//兼容ie
import "babel-polyfill";
import promise from "es6-promise";
promise.polyfill();

import VueWechatTitle from 'vue-wechat-title'
Vue.use(VueWechatTitle)
Vue.config.productionTip = false
router.beforeEach((to, from, next) => {
    if (Object.keys(to.meta).length > 0 && to.matched.length > 0) {
        let this_meta = to.matched[to.matched.length - 1].meta
        if (this_meta.title) document.title = this_meta.title + '-' + window.g.title
        let head = document.getElementsByTagName('head');
        let meta_keyword = document.createElement('meta');
        if (document.querySelector('meta[name="keywords"]')) {
            document.querySelector('meta[name="keywords"]').setAttribute('content', this_meta.content.keywords)
        } else {
            meta_keyword.setAttribute('name', 'keywords')
            meta_keyword.setAttribute('content', this_meta.content.keywords)
            head[0].appendChild(meta_keyword)
        }
        let meta_description = document.createElement('meta');
        if (document.querySelector('meta[name="description"]')) {
            document.querySelector('meta[name="description"]').setAttribute('content', this_meta.content.description)
        } else {
            meta_description.setAttribute('name', 'description')
            meta_description.setAttribute('content', this_meta.content.description)
            head[0].appendChild(meta_description)
        }
    }
    next()
});
/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js